import { Button, Flex, message, Modal, Spin, Tooltip, Typography } from "antd";
import { AllCategoryTable } from "./allcategorytable";
import { AllPersonaltable } from "./allpersonaltable";
import { DinamicTable } from "./dinamictable";
import { useGetPersonnelAnalyticalDataQuery, useReportPersonnelMutation } from "../../../../redux/api/mechanization/personnelApi";
import { PersonalBlockProps, PersonnelData, TransformedPersonnelData, ApiResponse } from "./types";
import { useTranslation } from 'react-i18next';
import style from './style.module.css';
import { PlusOutlined } from "@ant-design/icons";
import { GeneralData } from "../.."; 

const transformPersonnelData = (data: PersonnelData[]): TransformedPersonnelData[] => {
    return data.map(item => ({
        year: item.year,
        countArrived: item.countArrived,
        countDeparted: item.countDeparted
    }));
};


export const PersonalBlock: React.FC<PersonalBlockProps> = ({ alias }) => {
    const { data: apiData, error, isLoading } = useGetPersonnelAnalyticalDataQuery(alias) as { data?: ApiResponse, error?: any, isLoading: boolean };
    const {t} = useTranslation()
    const { i18n } = useTranslation();
  const [getReportPersonnel] = useReportPersonnelMutation();


    const fullPersonnelData = apiData?.success && Array.isArray(apiData.res)
        ? apiData.res
        : [];

    const transformedData = transformPersonnelData(fullPersonnelData);
    const governmentName = apiData?.success && apiData.res?.length > 0
    ? i18n.language === 'ru'
      ? apiData.res[0].government?.nameRu
      : apiData.res[0].government?.nameKy
    : 'Данные отсутствуют';

    const handleSubmit = async () => {
        try {
          const payload = {
            governmentAlias: alias,
            language: i18n.language,
          };
    
          const result = await getReportPersonnel(payload);
    
          if ('data' in result) {
            const blob = result.data;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Отчет_по_персоналу.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            message.success(t('reports.download_success'));
          } else {
            throw new Error(t('reports.download_failed'));
          }
        } catch (error: any) {
          Modal.error({
            title: t("msg.error"),
            content: error.message || t('reports.download_failed'),
          });
        }
      };
    

    const calculateCategoryData = (yearData: any) => {
        if (!yearData) return null;
        
        const total = (
            (yearData.countPolitical || 0) +
            (yearData.countAdministrative || 0) +
            (yearData.countNonState || 0) +
            (yearData.countTop || 0) +
            (yearData.countMiddle || 0) +
            (yearData.countOther || 0)
        );

        if (total === 0) return null;

        return [
            { 
                name: t("political positions"), 
                value: yearData.countPolitical || 0, 
                color: '#006837',
                labelPosition: { x: 180, y: 70 } 
            },
            { 
                name: t('Administrative civil servants'), 
                value: yearData.countAdministrative || 0, 
                color: '#39B54A',
                labelPosition: { x: 70, y: 150 } 
            },
            { 
                name: t('Non-governmental employees'), 
                value: yearData.countNonState || 0, 
                color: '#8DC63F',
                labelPosition: { x: 150, y: 220 } 
            },
            { 
                name: 'ТОП', 
                value: yearData.countTop || 0, 
                color: '#FBB03B',
                labelPosition: { x: 220, y: 180 } 
            },
            { 
                name: 'МОП', 
                value: yearData.countMiddle || 0, 
                color: '#F15A24',
                labelPosition: { x: 220, y: 120 } 
            },
            { 
                name: t('Others'), 
                value: yearData.countOther || 0, 
                color: '#29ABE2',
                labelPosition: { x: 200, y: 70 } 
            },
        ];
    };

    const categoryTableData = Object.fromEntries(
        ((['2022', '2023', '2024', '2025'])
            .map(year => {
                const yearData = calculateCategoryData(
                    fullPersonnelData?.find?.(item => item.year === parseInt(year))
                );
                return yearData ? [year, yearData] : null;
            })
            .filter(Boolean) || []) as [string, any][]
    );

    return (
        <div className={style.container}>
            {/* <GeneralData/> */}
            <div className={style.container_inner}>
                <div className={style.title}>
                    <h1>{t('Personnel')} - {governmentName || t('Data not available')}</h1>
                    <Button 
                        style={{marginLeft: '5px'}} 
                        type="primary" 
                        icon={<img src="../../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
                        onClick={handleSubmit}
                    >
                        {t('reports.download_report')}
                    </Button>
                </div>
                <div className={style.topRow}>
                    <AllPersonaltable data={fullPersonnelData} />
                    <DinamicTable data={transformedData} />
                </div>
                <AllCategoryTable data={categoryTableData}/>
            </div>
        </div>
    );
};
